<template>
  <el-select
    :loading="loading"
    :clearable="clearable"
    :value="value"
    :placeholder="placeholder"
    v-bind="$attrs"
    @change="typeChange"
  >
    <el-option
      v-if="isAll"
      :value="null"
      :label="allTxt"
    />
    <el-option
      v-if="isAreaAll"
      value="all"
      :label="allTxt"
    />
    <el-option
      v-for="item in list"
      :key="item[props.value]"
      :value="item[props.value]"
      :label="item[props.label]+(props.subLabel?`(${item[props.subLabel]})`:'')"
    >
      <div class="optionLabel">
        <div
          v-if="item.modelImgUrl"
          class="modelImg"
        ><img
          :src="item.modelImgUrl"
          alt=""
        /></div>
        <div class="labelTxt">
          {{ item[props.label] }}{{ props.subLabel?`(${item[props.subLabel]})`:'' }}
        </div>
      </div>

    </el-option>
  </el-select>
</template>

<script>
export default {
  name: 'CommonSelect',
  props: {
    value: {
      type: [String, Array],
      default: ''
    },
    extraList: {
      type: Array,
      default: () => {
        return []
      }
    },
    placeholder: {
      type: String,
      default: '请选择'
    },
    dictionaryTypeCode: {
      type: String,
      default: ''
    },
    request: {
      type: Function,
      default: () => {}
    },
    params: {
      type: Object,
      default: () => {}
    },
    props: {
      type: Object,
      default: () => {}
    },
    isPost: {
      type: Boolean,
      default: true
    },
    isAll: {
      type: Boolean,
      default: false
    },
    isAreaAll: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    },
    allTxt: {
      type: String,
      default: '全部'
    }
  },
  data() {
    return {
      loading: false,
      list: []
    }
  },
  mounted() {
    if (this.isPost) {
      this.getData()
    }
  },
  methods: {
    getData() {
      this.loading = true
      this.request(this.params)
        .then((res) => {
          if (Object.prototype.toString.call(res.data) === '[object Object]') {
            this.list = res.data.records.concat(this.extraList || [])
            if (res.data.records.length > 0) {
              this.$emit(
                'getDataSucess',
                res.data.records[0][this.props.value],
                res.data.records[0]
              )
            } else {
              this.$emit('getDataSucess')
            }
          } else {
            this.list = res.data.concat(this.extraList || [])
            if (res.data.length > 0) {
              this.$emit(
                'getDataSucess',
                res.data[0][this.props.value],
                res.data[0]
              )
            }
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    typeChange(e) {
      const item = this.list.find((item) => item[this.props.value] === e)
      this.$emit('change', e, item)
      this.$emit('input', e, item)
    },
    clear() {
      this.list = []
    }
  }
}
</script>

<style lang="scss" scoped>
.el-select {
  width: 100%;
}
.HeaderForm {
  background: #fff;
  padding-top: 10px;
}
.flexEnd {
  display: flex;
  justify-content: flex-end;
}
.optionLabel {
  display: flex;
  align-items: center;
  .modelImg {
    width: 30px;
    height: 30px;
    margin-right: 6px;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}
</style>
